var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRefreshRolesIcon = function SvgRefreshRolesIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.347 18.295a.428.428 0 0 0 0-.626.443.443 0 0 0-.635 0c-2.042 2.013-5.353 1.968-7.348-.045-1.996-2.013-2.042-5.28 0-7.293 2.04-2.013 5.352-1.968 7.393.09A5.045 5.045 0 0 1 19.254 14v.179l-1.497-1.253c-.182-.134-.499-.134-.635.045-.182.179-.136.492.045.626l2.177 1.79c.137.179.273.179.409.179.136 0 .226-.045.317-.18l1.815-2.236c.18-.179.136-.492-.046-.626-.181-.135-.499-.135-.635.044l-1.043 1.253c-.09-3.31-2.903-5.95-6.26-5.816-3.356.134-6.032 2.863-5.896 6.174.09 3.31 2.903 5.95 6.26 5.816.997 0 1.995-.268 2.902-.805.408-.269.817-.537 1.18-.895z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRefreshRolesIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/refresh-roles-icon.9055b2f06b5cf4a1d336f95474adf952.svg";